import React, { useEffect, useState } from "react";
import { cancelRequest } from "../../../utils/queries";

import {
  Form,
  Label,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faTimes } from "@fortawesome/free-solid-svg-icons";
import Alerts from "../../molecules/Alerts";
import { v4 as uuidv4 } from "uuid";
import "../shared/BrandModal.css";

export const RequestModal = (props) => {
  const [alerts, setAlerts] = useState([]);

  const [showAdditionalError, setShowAdditionalError] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    setReason(props.request?.cancelledByReason);
  }, [props.request]);

  const addAlert = (message, color) => {
    let id = uuidv4();
    setAlerts([...alerts, { message: message, id: id, color: color }]);
  };

  const toggle = () => {
    props.setToggle(!props.toggle);

    setReason(props.request.cancelledByReason);
  };

  const submitted = async (e) => {
    e.preventDefault();

    let validated = validate();

    if (!validated) {
      return;
    }

    try {
      let request = await cancelRequest(props.request.id, reason);

      props.onUpdateRequest(request);
    } catch (error) {
      addAlert("Could not cancel request. Please contact IT.", "danger");
    }

    toggle();
  };

  const validate = () => {
    let isSuccess = true;

    if (!reason) {
      setShowAdditionalError(true);
      isSuccess = false;
    }

    return isSuccess;
  };

  return props.request ? (
    <Modal isOpen={props.toggle} toggle={toggle} size="lg" className="brand-modal">
      <ModalHeader toggle={toggle}>Cancel Request</ModalHeader>
      <ModalBody>
        <Alerts alerts={alerts} setAlerts={setAlerts} />
        <p className="brand-modal__desc">
          Please provide a reason for cancelling this request.
        </p>
        <Form onSubmit={submitted}>
          <FormGroup>
            <Label for="reason">Reason</Label>
            <Input
              type="textarea"
              name="reason"
              id="reason"
              placeholder="Reason for cancelling request required"
              onChange={(e) => setReason(e.target?.value)}
              value={reason || ""}
              disabled={props.request.cancelled === true}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button
              type="submit"
              className="brand-modal__btn brand-modal__btn--danger"
              disabled={props.request.cancelled === true}
            >
              <FontAwesomeIcon icon={faBan} /> Mark as cancelled
            </button>
            <button
              type="button"
              className="brand-modal__btn brand-modal__btn--cancel"
              onClick={toggle}
            >
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  ) : null;
};
